type RuntimeConfig = Partial<Record<string, string>>;

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

const readEnv = (key: string, fallback = ''): string => {
  const runtimeValue = window.__RUNTIME_CONFIG__?.[key];
  if (typeof runtimeValue === 'string' && runtimeValue.length > 0) {
    return runtimeValue;
  }
  const value = (import.meta.env as Record<string, unknown>)[key];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
};

export const ENV = {
  API_URL: readEnv('VITE_API_URL'),
  AUTH_API_URL: readEnv('VITE_AUTH_API_URL'),
  ASSISTANT_API_URL: readEnv('VITE_ASSISTANT_API_URL', '/api/chat'),
  WORKFLOW_API_URL: readEnv('VITE_WORKFLOW_API_URL'),
  AUTHENTIK: {
    AUTHORIZE_URL: readEnv('VITE_AUTHENTIK_AUTHORIZE_URL'),
    TOKEN_URL: readEnv('VITE_AUTHENTIK_TOKEN_URL'),
    REDIRECT_URI: readEnv('VITE_AUTHENTIK_REDIRECT_URI'),
    CLIENT_ID: readEnv('VITE_AUTHENTIK_CLIENT_ID'),
    END_SESSION_URL: readEnv('VITE_AUTHENTIK_END_SESSION_URL'),
    SCOPE: readEnv('VITE_AUTHENTIK_SCOPE', 'openid profile email offline_access'),
  },
} as const;

